import type {Thread} from '@github-ui/diff-lines/conversation-types'
import styles from './ThreadSnippet.module.css'
import {getCommentSnippet, getLatestComment} from '../util/thread-comment-accessors'

interface ThreadSnippetProps {
  thread?: Thread | null
}

export function ThreadSnippet({thread}: ThreadSnippetProps) {
  const lastComment = thread && getLatestComment(thread)
  if (!lastComment) return null
  return <span className={styles.ThreadSnippet}>{getCommentSnippet(lastComment)}</span>
}
